import React, { useEffect } from "react";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import UserSettingsLayout from "shared/layouts/user-settings";
import styled from "@emotion/styled";
import SearchQueriesList from "@components/list/search-queries";
import { en,es} from "@lang"

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

function SearchQueriesPage(props: any) {
  const titleT = useTranslations("title-pages");
  const t = useTranslations("ProfileSearchQueries");
  const router = useRouter();
  const user = useAppSelector((state) => state.Auth.user);

  useEffect(() => {
    if (!user) router.push(CPagesPath.es.signin);
  });

  if (!user) return null;

  return (
    <>
      <Head>
        <title>{titleT("profile-search_queries")}</title>
      </Head>
      <Container>
        <PageTitle>{t("title")}</PageTitle>
        <SearchQueriesList />
      </Container>
    </>
  );
}

SearchQueriesPage.Layout = UserSettingsLayout;
export default SearchQueriesPage;

const PageTitle = styled.h1`
  color: var(--color-brand-blue-main);
  font-weight: 500;
  margin-bottom: 30px;
`;

const Container = styled.section`
  max-width: 1260px;
  margin: auto;
  padding: 30px 20px;
`;
